import styled from 'styled-components/macro'
// @ts-ignore
import Toggle from 'react-toggle'
import { commonModalStyle, commonModalContentStyle, glass } from 'src/global/helpers'

export const Modal = styled.div`
  ${commonModalStyle}
  width: 780px;
  background: ${props => props.theme.white};
  border: 1px solid ${props => props.theme.border};
  transition: opacity 0.25s ease-in-out;
  color: ${props => props.theme.normalText};
  box-shadow: 0 4px 42px ${props => props.theme.shadow};
  overflow: hidden;

  .ios-toggle {
    margin-top: 8px;
    width: calc(((780px - (16px * 3)) / 2) - 2px - 8px);

    @media (max-width: 768px) {
      width: 100%;
    }

    background: ${props => props.theme.pageBackground};
  }

  &.teal {
    button:not([data-variant='as-text']):not([data-variant='secondary']) {
      background: ${props => props.theme.teal};
    }

    [data-variant='as-text'] {
      color: ${props => props.theme.teal};
    }
  }

  &.closed {
    pointer-events: none;
    opacity: 0;
  }

  p.info {
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 12px;
    padding: 16px 5vw 0 5vw;
    text-align: center;

    .icon {
      margin-right: 5px;
      color: ${props => props.theme.accent};
    }
  }

  .product-variants {
    width: 100%;
  }

  .product-variant {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    position: relative;
    width: 100%;
    margin: 8px 0;
    border: 1px solid ${props => props.theme.border}88;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    column-gap: 10px;

    &.static {
      margin-top: 0;
      border: none;
      box-shadow: none;
      padding: 0;
    }

    .remove-button {
      position: absolute;
      top: 16px;
      right: 16px;
      font-size: 16px;
      cursor: pointer;

      :hover {
        color: ${props => props.theme.red};
      }

      @media (max-width: 768px) {
        /* top: 16px;
        right: 16px;
        bottom: auto; */
      }
    }

    &:nth-of-type(even) {
      /* background: ${props => props.theme.accent}22; */
    }

    &:hover {
      background: #11b7f311;
    }
  }

  .plus-button {
    background: ${props => props.theme.white};
    height: 35px;
    width: 35px;
    border-radius: 100%;
    overflow: hidden; /* the label must not poke out while the width animates */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 1px 8px #818e9988;
    transition: width 0.075s cubic-bezier(0.25, 1, 0.32, 1);
    position: absolute;
    z-index: 1000;
    right: 8px;
    bottom: 0;
    top: 0;
    margin: auto;
    transition:
      width 0.125s cubic-bezier(0.25, 1, 0.32, 1),
      border-radius 0.25s cubic-bezier(0.25, 1, 0.32, 1) 0.075s;

    /* On phones the label sits above the inputs, so the disc hangs from the row's bottom instead:
       8px of field margin plus 3px to centre 35px on the 41px input, flush with the right edge */
    @media (max-width: 768px) {
      top: auto;
      bottom: 11px;
      right: 0;
      margin: 0;
    }

    span {
      color: ${props => props.theme.white};
      margin-right: 16px;
      display: none;
      font-weight: 500;
      font-size: 16px;
      white-space: nowrap;
    }

    svg {
      font-size: 20px;
      color: ${props => props.theme.accent};
      padding: 0 4px;
    }

    :hover {
      transition:
        width 0.125s cubic-bezier(0.25, 1, 0.32, 1) 0.0125s,
        border-radius 0.025s cubic-bezier(0.25, 1, 0.32, 1);
      background: ${props => props.theme.accent};

      svg {
        color: ${props => props.theme.white};
      }
    }

    :not(.in-list):hover {
      width: auto;
      border-radius: 8px;
      width: 260px;

      span {
        display: inline;
      }
    }
  }

  .add-variant-row {
    width: 100%;
    display: flex;
    justify-content: center;

    .plus-button {
      position: static;
      background: ${props => props.theme.accent};
      width: auto;
      border-radius: 8px;
      transition: box-shadow 0.075s ease-out;

      &:hover {
        width: auto;
        box-shadow: 0 4px 12px ${props => props.theme.mutedText};
      }

      span {
        display: inline;
      }

      .fa {
        color: ${props => props.theme.white};
      }
    }
  }

  .magic-button {
    width: 132px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    height: 100%;
    margin-right: -6px;
    background: linear-gradient(20deg, hsl(206deg 100% 50%), hsl(192deg 98% 52%));
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.25, 1, 0.32, 1);
    position: absolute;
    right: 10px;
    bottom: 4px;
    height: 40px;
    z-index: 1001;
    color: ${props => props.theme.white};
    font-weight: 600;

    @media (max-width: 768px) {
      width: 75px;

      span {
        display: none;
      }
    }

    img {
      transition: all 0.5s cubic-bezier(0.25, 1, 0.32, 1);
      width: 26px;
    }

    &:hover {
      filter: drop-shadow(2px 0px 4px #00000022);

      img {
        transform: scale(1.18) rotate(13deg);
      }
    }

    &.loading {
      opacity: 0.6;
      pointer-events: none;
      filter: none;

      img {
        animation: rotate 2.5s linear infinite;
      }
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(359deg);
      }
    }

    @media (max-width: 768px) {
      width: 50px;
    }
  }

  .disclaimer {
    font-size: 14px;
    font-style: italic;
    color: ${props => props.theme.mutedText};
    font-weight: 500;
    text-align: right;
    width: 100%;

    i {
      margin-right: 4px;
    }
  }

  .allergen-list {
    display: flex;
    flex-wrap: wrap;

    .allergen {
      padding: 4px 8px;
      border-radius: 16px;
      background: ${props => props.theme.white};
      border: 1px solid ${props => props.theme.border};
      margin-top: 8px;
      margin-right: 8px;
      cursor: pointer;
      font-size: 15px;

      @media (hover) {
        :hover {
          border-color: ${props => props.theme.orange};
          color: ${props => props.theme.orange};
        }
      }

      &.selected {
        color: ${props => props.theme.orange};
        background: ${props => props.theme.orange}0f;
        border-color: ${props => props.theme.orange}aa;
        font-weight: 500;
        border-width: 2px;
      }
    }
  }

  .product-properties {
    display: flex;
    flex-wrap: wrap;

    .product-property {
      padding: 4px 10px;
      border-radius: 16px;
      background: ${props => props.theme.white};
      border: 1px solid ${props => props.theme.border};
      margin-top: 8px;
      margin-right: 8px;
      cursor: pointer;
      font-size: 15px;
      display: flex;
      align-items: center;

      img {
        height: 14px;
        margin-right: 6px;
        filter: saturate(0);
      }

      @media (hover) {
        :hover {
          &.orange {
            color: ${props => props.theme.orange};
            border-color: ${props => props.theme.orange};
          }
          &.green {
            color: ${props => props.theme.green};
            border-color: ${props => props.theme.green};
          }
          &.red {
            color: ${props => props.theme.red};
            border-color: ${props => props.theme.red};
          }
          &.blue {
            color: ${props => props.theme.blue};
            border-color: ${props => props.theme.blue};
          }

          img {
            filter: saturate(1);
          }
        }
      }

      &.selected {
        &.red {
          color: ${props => props.theme.red};
          background: ${props => props.theme.red}11;
          border-color: ${props => props.theme.red};
        }
        &.blue {
          color: ${props => props.theme.blue};
          background: ${props => props.theme.blue}11;
          border-color: ${props => props.theme.blue};
        }

        &.orange {
          color: ${props => props.theme.orange};
          background: ${props => props.theme.orange}11;
          border-color: ${props => props.theme.orange};
        }
        &.green {
          color: ${props => props.theme.green};
          background: ${props => props.theme.green}11;
          border-color: ${props => props.theme.green};
        }

        img {
          filter: saturate(1);
        }

        font-weight: 500;
        border-width: 2px;
      }
    }
  }
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 24px 16px;
  padding-right: 45px;

  width: 100%;
  background: ${props => props.theme.pageBackground};
`

export const CloseButtonWrapper = styled.div`
  cursor: pointer;
  margin-top: -12px;
  position: absolute;
  right: 17px;
  top: 25px;
  transform: rotate(45deg);

  width: 50px;
  height: 50px;

  margin-right: -11px;

  :hover {
    opacity: 0.6;
  }
`

export const CloseButtonLineOne = styled.div`
  width: 22px;
  height: 2px;
  background: #bbc3c8;
  display: inline-block;
  position: relative;
  top: 0px;
  left: 11px;
`

export const CloseButtonLineTwo = styled.div`
  height: 22px;
  width: 2px;
  background: #bbc3c8;
  display: inline-block;
  margin-left: -22.5px;
  position: relative;
  top: 10px;
  left: 21px;
`

export const ModalContent = styled.div`
  padding: 16px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  transition: all 0.3s ease-in-out;
  overflow: auto;
  transition: all 0.3s ease-in-out;

  ${commonModalContentStyle}

  .image-dropper {
    display: flex;
    justify-content: center;
    width: 100%;

    p {
      text-align: center;
      max-width: 60vw;
      font-weight: 400;
    }

    /* With a photo: the photo stays centred in the middle column, which is exactly its size, so the
       row of tag and info box can anchor to its corner. The container type lets the photo cap its
       width at the dropper's width (100cqw) without the auto column fighting it */
    &.with-photo {
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      align-items: end;
      position: relative;
      container-type: inline-size;

      .product-photo {
        grid-column: 2;
        grid-row: 1;
      }

      /* On a phone a wide photo already spans the frame at rest, so compare mode takes the content's
         side padding too: the only room left for it to grow into */
      &.compare {
        @media (max-width: 768px) {
          width: calc(100% + 32px);
          margin: 0 -16px;
        }
      }
    }
  }

  .image-icon-wrapper {
    position: absolute;
    left: 12px;
    top: 8px;
    z-index: 15;
    pointer-events: none;
  }

  .toggles-wrapper {
    margin: 16px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
  }

  .toggle-wrapper {
    display: flex;
    align-items: center;
    align-items: flex-end;
    padding-left: 0;

    @media (max-width: 768px) {
      width: 100%;
    }

    span {
      padding-left: 8px;
      padding-bottom: 2px;
      white-space: nowrap;
    }
  }
`

export const ModalFooter = styled.div`
  padding: 16px;
  background: ${props => props.theme.pageBackground};
  display: flex;
  justify-content: space-around;
  align-items: center;

  button {
    margin-top: 0;
  }
`

export const ProductPropertyToggle = styled(Toggle)`
  &.react-toggle--focus .react-toggle-thumb {
    box-shadow: none !important;
  }

  &.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${props => props.theme.mutedText}44;
  }

  &.react-toggle .react-toggle-track {
    background-color: ${props => props.theme.mutedText}88;
  }

  &.react-toggle:not(.react-toggle--checked) .react-toggle-thumb {
    border-color: ${props => props.theme.mutedText}88;
  }

  &.react-toggle--checked .react-toggle-thumb {
    border-color: ${props => props.theme.accent};
  }

  &.react-toggle--checked .react-toggle-track {
    background-color: ${props => props.theme.accent};
  }

  &.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${props => props.theme.accent}bb;
  }
`

export const DropArea = styled.div`
  background-color: #eceff144;
  border: 1px solid ${props => props.theme.border};
  border-radius: 8px;
  width: 100%;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: ${props => props.theme.normalText};

  &.dragged {
    background: ${props => props.theme.accent}10;
    border: 1px solid ${props => props.theme.accent};
    color: ${props => props.theme.accent};

    > div {
      color: ${props => props.theme.accent};
    }
  }
`

// Sized by height only, the width follows the photo's ratio. Compare mode doubles it, animated.
export const ProductImageWrapper = styled.div`
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  isolation: isolate; /* the layers below stack among themselves */

  /* A soft shade from the top-left corner, so the glass buttons read on a bright photo, and a faint
     1px ring inside the edge, so a white photo still shows where it ends */
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(154deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0) 40%);
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
    pointer-events: none;
    z-index: 1;
  }
  justify-content: flex-end;
  display: inline-flex;
  flex-direction: column;
  margin: auto;

  /* Height-driven, doubled in compare mode, but a wide photo stops growing when it reaches the sides.
     Never under 240px, so on a short screen a portrait photo stays wide enough for its own buttons */
  img {
    display: block;
    width: auto;
    height: auto;
    max-height: max(32vh, 240px);
    max-width: 100cqw;
    transition: max-height 400ms cubic-bezier(0.25, 1, 0.32, 1) 700ms;
  }

  &.compare img {
    max-height: max(60vh, 240px);
  }

  /* The retouched photo is stacked over the original and the tick fades it in and out: both stay loaded,
     so flipping never reloads or flickers */
  img.retouched {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    max-height: none;
    opacity: 0;
    transition: opacity 250ms ease;
  }

  img.retouched.visible {
    opacity: 1;
  }

  /* While a retouch runs both photos blur, the stacked retouched one included (the preview shows them together) */
  &.retouching img {
    filter: blur(2px);
    transform: scale(1.02);
  }
`
// White glass buttons in a row 8px inside the photo's top-left corner: the trash disc, then the "Schimbă"
// pill 8px after it (the disc is 30px plus its 1px border on each side, so the pill starts at 48px)
export const ImageActionButton = styled.div`
  ${glass}
  box-shadow: none; /* the corner shade and the rim are enough over a photo */
  --tint: rgba(255, 255, 255, 0.35);
  /* The white tint gets a darkened backdrop, so the white text keeps its contrast on a bright photo */
  -webkit-backdrop-filter: blur(6px) saturate(1.8) brightness(0.7);
  backdrop-filter: blur(6px) saturate(1.8) brightness(0.7);
  position: absolute;
  z-index: 2; /* over the corner shade */
  top: 8px;
  left: 48px;
  padding: 6px 14px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;

  @media (hover: hover) {
    &:hover {
      --tint: rgba(255, 255, 255, 0.5);
    }
  }

  &.danger {
    left: 8px;
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const ErrorText = styled.div`
  margin-top: 8px;
  color: ${props => props.theme.red};
  font-size: 14px;
  font-weight: 500;
`

export const UploadImageBackground = styled.img`
  width: 100%;
  position: absolute;
  left: 0px;
  opacity: 0.15;
  z-index: -1;
  min-height: 100%;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  position: relative;

  @media (max-width: 768px) {
    width: 100% !important;
    margin-left: 0px !important;
  }
`

export const Flag = styled.div`
  position: absolute;
  bottom: 8px;
  right: 13px;
`

export const RetouchOverlay = styled.div`
  position: absolute;
  z-index: 2; /* over the corner shade */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.34);
  pointer-events: none;

  /* No card: the darkened, blurred photo is the backdrop, the text and the bar sit straight on it */
  .readout {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: calc(100% - 32px); /* 16px inside the photo's sides */
    color: #ffffff;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.01em;
  }

  /* The track is a thin glass pill, the same white glass as the corner buttons */
  .progress {
    ${glass}
    --tint: rgba(255, 255, 255, 0.35);
    -webkit-backdrop-filter: blur(6px) saturate(1.8) brightness(0.7);
    backdrop-filter: blur(6px) saturate(1.8) brightness(0.7);
    width: 100%;
    max-width: 280px; /* fills a narrow photo, stops short on a wide one */
    height: 14px;
    padding: 1px; /* a hair of track around the white fill */
    cursor: default;
  }

  .fill {
    height: 100%;
    border-radius: 999px;
    background: #ffffff;
    transition: width 500ms linear;
  }
`

// Holds the pill centred at the photo's bottom, 8px up. Absolutely placed in the photo's grid cell so it
// never widens the column, and unlike the photo box it does not clip, so on a narrow portrait photo the
// pill simply runs past both sides
export const RetouchBar = styled.div`
  position: absolute;
  /* both lines spelled out: for an absolutely placed child an auto end line means the grid's edge */
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  z-index: 1;
`

// Glass pill holding the light Checkbox, the same white glass as the corner buttons; only the tick tells on from off
export const RetouchTag = styled.div`
  ${glass}
  box-shadow: none; /* the corner shade and the rim are enough over a photo */
  --tint: rgba(255, 255, 255, 0.35);
  -webkit-backdrop-filter: blur(6px) saturate(1.8) brightness(0.7);
  backdrop-filter: blur(6px) saturate(1.8) brightness(0.7);

  /* The label carries the padding and so fills the pill: a click anywhere on it flips the box.
     The round box sits concentric with the pill's left end */
  label.checkbox {
    padding: 6px 14px 6px 8px;
  }

  @media (hover: hover) {
    &:hover {
      --tint: rgba(255, 255, 255, 0.5);
    }
  }

  /* Past the free limit: amber reads as a limit, not an error; a click opens the limit dialog */
  &.limit-reached {
    --tint: rgba(245, 124, 0, 0.72);

    @media (hover: hover) {
      &:hover {
        --tint: rgba(245, 124, 0, 0.85);
      }
    }
  }
`
